<!-- prettier-ignore -->

<form [formGroup]="sendChat" class="chat-bot-info-container">

    <div class="chat-bot-info-container__header">
        <div style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="29" height="30" viewBox="0 0 29 30" fill="none">
                <mask id="mask0_1_1898" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="29" height="30">
                    <rect y="0.5" width="29" height="29" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_1_1898)">
                    <path d="M14.5 16.2084L4.83329 10.1667V22.25H15.7083V24.6667H4.83329C4.16871 24.6667 3.59979 24.4301 3.12652 23.9568C2.65326 23.4835 2.41663 22.9146 2.41663 22.25V7.75004C2.41663 7.08546 2.65326 6.51653 3.12652 6.04327C3.59979 5.57001 4.16871 5.33337 4.83329 5.33337H24.1666C24.8312 5.33337 25.4001 5.57001 25.8734 6.04327C26.3467 6.51653 26.5833 7.08546 26.5833 7.75004V16.2084H24.1666V10.1667L14.5 16.2084ZM14.5 13.7917L24.1666 7.75004H4.83329L14.5 13.7917ZM22.9583 28.2917L21.2666 26.6L23.1698 24.6667H18.125V22.25H23.1698L21.2364 20.3167L22.9583 18.625L27.7916 23.4584L22.9583 28.2917ZM4.83329 10.1667V23.4584V16.2084V16.299V7.75004V10.1667Z" fill="#2A4B5A"/>
                </g>
            </svg>
        </div>
        <span>{{ 'Enviar chat por email' | translate }}</span>
    </div>

    <div class="chat-bot-info-container__body">
        <span>{{ 'Envía la conversación completa con el chatbot a tu correo electrónico y ten siempre a mano tus consultas.' | translate }}</span>
        <div class="chat-bot-info-container__body__input-container" [ngClass]="{'error-mail' : errorMail()}">
            <input formControlName="email" id="email" placeholder="example@iurban.es" autocomplete="off" (keyup)="resetError()">
        </div>
        @if(errorMail()){
            <span class="error-span-email">{{'Email no válido' | translate}}</span>
        }
    </div>

    <div class="chat-bot-info-container__footer">
        <button class="cancel" (click)="closeModal()">{{ 'Cancelar' | translate }}</button>
        <button (click)="sendMail()" [ngClass]="{'loader' : sendingMail()}">
            @if(sendingMail()){
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
                    <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
                        <stop offset="0" stop-color="#FFFFFF"></stop>
                        <stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop>
                        <stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop>
                        <stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop>
                        <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop>
                    </radialGradient>
                    <circle transform-origin="center" fill="none" stroke="url(#a12)" stroke-width="40" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
                        <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
                    </circle>
                    <circle transform-origin="center" fill="none" opacity=".2" stroke="#FFFFFF" stroke-width="40" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
                </svg>
            } @else {
                {{ 'Enviar' | translate }}
            }
        </button>
    </div>
    
</form>